import React, {useCallback} from "react";
import {useParams} from "react-router";
import {DiaEditorCreateRedirectFunction, useDiaEditor} from "../../components/DiaEditor";
import {NonIdealState} from "../../components/NonIdealState";
import WaitSpinner from "../../components/wait-spinner";
import {
    CreateSalesTeamMutationMutation,
    GetSalesTeamQueryQueryResult,
    SalesTeam,
    UpdateSalesTeamMutationMutation,
    UpdateSalesTeamMutationMutationResult,
    useCreateSalesTeamMutationMutation,
    useGetSalesTeamQueryQuery,
    useUpdateSalesTeamMutationMutation
} from "../../generated/graphql";
import {useUserContext} from "../../contexts/user-context";
import {SalesTeamForm} from "./Form";
import * as yup from "yup";
import { MutationResult } from "@apollo/client/react";


const relationships = {
    defaultCurrency:'connect',
    proposalOptions:'connect',
    reportingCurrency:'connect',
    manager:'connect'
};


const schema =  yup.object().shape({
    name: yup.string().min(1),
    prefix: yup.string().min(2),
    defaultCurrency: yup.object().required()
});

function blankValues():SalesTeam {
    return {
        id: 'new',
        name:'',
        prefix:'',
        document_footer:'',
        contact_email:'',
        url:'',
        defaultCurrency:null,
        reportingCurrency:null,
        supports_commission:false,
        disclaimer_commission:'',
        commission_financial_notes:'',
        include_dashboard_all:true,
        proposalOptions:[]
    };
}
export function SalesTeamEditor() {
    const params = useParams();
    const isNew = (params.id=='new');
    const user = useUserContext();
    const query = useGetSalesTeamQueryQuery({variables:{id:params.id},skip:isNew});
    const [saveMutation,saveResult] = useUpdateSalesTeamMutationMutation();
    const [createMutation,createResult] = useCreateSalesTeamMutationMutation();
    const readOnly = !(user.hasPermission('salesteams.edit'));
    const save = useCallback(({values})=>{
        return saveMutation({variables:{input:values}});
    },[saveMutation]);
    const create = useCallback(({values})=>{
        return createMutation({variables:{input:values}});
    },[createMutation]);
    const getValue = useCallback((result:GetSalesTeamQueryQueryResult)=>{
        return result?.data?.salesTeam;
    },[]);
    const getSaveValue = useCallback((result:UpdateSalesTeamMutationMutationResult)=>{
        return result?.data?.updateSalesTeam;
    },[]);
    
    const getCreateRedirect = useCallback<DiaEditorCreateRedirectFunction<MutationResult<CreateSalesTeamMutationMutation>>>(({data,baseUrl})=>{
        return baseUrl+(data.data?.createSalesTeam?.id);
    },[]);
    const data = useDiaEditor<SalesTeam,GetSalesTeamQueryQueryResult,CreateSalesTeamMutationMutation,UpdateSalesTeamMutationMutation>({
        save,
        saveResult,
        create,
        createResult,
        query:query,
        relationships:relationships,
        baseUrl:'/settings/sales-teams/',
        blankValues:blankValues,
        label:'Sales Teams',
        permission:'sales_teams',
        validationSchema:schema,
        getValue:getValue,
        getSaveValue:getSaveValue,
        getCreateRedirect:getCreateRedirect
    });
    if (query.error) {
        return <NonIdealState
            severity="error"
            title="An error has occurred"
            message="GraphQL error encountered"
        />;
    }
    console.log('data0 is',data);
    if(data.form.status=='loading') {
        return <WaitSpinner variant="panel"/>;
    }
    console.log('data is',data);
    return <><SalesTeamForm diaForm={data.form} readOnly={readOnly}/>
        {data.confirmation}
    </>;
}